import sans400 from '@expo-google-fonts/ibm-plex-sans/400Regular/IBMPlexSans_400Regular.ttf?url';
import sans400i from '@expo-google-fonts/ibm-plex-sans/400Regular_Italic/IBMPlexSans_400Regular_Italic.ttf?url';
import sans500 from '@expo-google-fonts/ibm-plex-sans/500Medium/IBMPlexSans_500Medium.ttf?url';
import sans600 from '@expo-google-fonts/ibm-plex-sans/600SemiBold/IBMPlexSans_600SemiBold.ttf?url';
import sans700 from '@expo-google-fonts/ibm-plex-sans/700Bold/IBMPlexSans_700Bold.ttf?url';
import deva400 from '@expo-google-fonts/ibm-plex-sans-devanagari/400Regular/IBMPlexSansDevanagari_400Regular.ttf?url';
import deva500 from '@expo-google-fonts/ibm-plex-sans-devanagari/500Medium/IBMPlexSansDevanagari_500Medium.ttf?url';
import deva600 from '@expo-google-fonts/ibm-plex-sans-devanagari/600SemiBold/IBMPlexSansDevanagari_600SemiBold.ttf?url';
import deva700 from '@expo-google-fonts/ibm-plex-sans-devanagari/700Bold/IBMPlexSansDevanagari_700Bold.ttf?url';

/**
 * The exact font files the PDF engine embeds. The UI uses the same faces, and the PDF worker
 * loads these URLs, so on-screen text and printed text match. Served from our own origin,
 * so they work offline.
 */
export const REPORT_FONT_URLS = [
  sans400,
  sans400i,
  sans500,
  sans600,
  sans700,
  deva400,
  deva500,
  deva600,
  deva700,
];

const UI_FACES: [string, string, string][] = [
  [sans400, '400', 'normal'],
  [sans400i, '400', 'italic'],
  [sans500, '500', 'normal'],
  [sans600, '600', 'normal'],
  [sans700, '700', 'normal'],
];

export function registerUiFonts() {
  for (const [url, weight, style] of UI_FACES) {
    const face = new FontFace('IBM Plex Sans', `url(${url})`, { weight, style, display: 'swap' });
    document.fonts.add(face);
    void face.load().catch(() => undefined);
  }
}
